import React from "react";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import HotelIcon from "@mui/icons-material/Hotel";
import FlagIcon from "@mui/icons-material/Flag";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

function HomeProductsSection() {
  const products = [
    {
      title: "Flight",
      description: "Access global fares with instant ticketing.",
      icon: <FlightTakeoffIcon fontSize="medium" className="text-white" />,
      bg: "bg-blue-500",
    },
    {
      title: "Hotel",
      description: "Thousands of properties worldwide.",
      icon: <HotelIcon fontSize="medium" className="text-white" />,
      bg: "bg-red-500",
    },
    {
      title: "Tour",
      description: "Curated experiences you can resell instantly.",
      icon: <FlagIcon fontSize="medium" className="text-white" />,
      bg: "bg-purple-700",
    },
    {
      title: "Insurance",
      description: "Protect your customers with flexible coverage.",
      icon: <HealthAndSafetyIcon fontSize="medium" className="text-white" />,
      bg: "bg-green-500",
    },
    {
      title: "White-label Websites",
      description: "Your own branded booking site, live in 1 day",
      icon: <WebAssetIcon fontSize="medium" className="text-white" />,
      bg: "bg-gray-800",
    },
    {
      title: "API Access",
      description: "For agents building custom travel solutions",
      icon: <RocketLaunchIcon fontSize="medium" className="text-white" />,
      bg: "bg-cyan-500",
    },
  ];

  return (
    <section className="w-full bg-gray-50 py-12 px-4 flex flex-col items-center">
      {/* Section Title */}
      <h2 className="text-2xl font-bold mb-8 text-center">Our Products</h2>

      {/* Product Grid */}
      <div className="grid grid-cols-2 gap-2 max-w-3xl w-full">
        {products.map((p, i) => (
          <div
            key={i}
            className="flex flex-col items-start gap-4 bg-white p-3 rounded-2xl shadow-sm"
          >
            <div className="flex gap-2 items-center">
              <div
                className={`flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-lg ${p.bg}`}
              >
                {p.icon}
              </div>
              <span className="font-semibold text-base">{p.title}</span>
            </div>
            <div>
              <p className="text-gray-500 text-sm mt-1">{p.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeProductsSection;
